import * as R from 'ramda';
import { combineReducers } from 'redux';
import { ORGANISATION_INITIALISE, ORGANISATION_ADD_NETWORKS } from '../actions';
import { NETWORK_UPDATE_NETWORK } from '../../network/actions';
import {
  UPDATE_NETWORK_BY_ID_SUCCESS,
  IMPORT_COMMUNITY_SUCCESS,
  IMPORT_COMMUNITIES_BULK_SUCCESS,
} from '../../admin/actions/integration-communities';

const items = (state = [], action) => {
  switch (action.type) {
    case ORGANISATION_INITIALISE:
      return R.pluck('id', action.networks);
    case NETWORK_UPDATE_NETWORK:
      if (!R.contains(action.network.id, state)) return state;

      return [...state];
    case ORGANISATION_ADD_NETWORKS:
      return R.concat(state, R.pluck('id', action.items));
    case UPDATE_NETWORK_BY_ID_SUCCESS:
    case IMPORT_COMMUNITY_SUCCESS:
      if (!R.contains(action.data.id, state)) {
        return R.concat(state, [action.data.id]);
      }
      return state;
    case IMPORT_COMMUNITIES_BULK_SUCCESS:
      const newNetworkIds = Array.isArray(action.data)
        ? action.data.map((network) => network.id).filter((id) => !R.contains(id, state))
        : [];
      return R.concat(state, newNetworkIds);
    case 'admin/DELETE_NETWORK':
      return R.reject(R.equals(action.id), state);
    default: return state;
  }
};

export default combineReducers({ items });
